<div id="elevaagendaedu">
  <nav>
    <ae-buttons>
      <ae-buttons-button>
        <a
          href="/responsavel/9c6eed41-af0e-48ee-a765-ec84051d49b5/aluno/6f7fbea2-8846-480e-b899-34a96b7eac4d/Fpxi6Fx5bWB8Eg92ZiCquXg2fXyRMccpnls2HtrI-YqyOUZ5tW0FrKdmdRy5n1tJeu1uIcaYYg2liDUSI9EwDYDJfI0hFYjus7_p4N1EzxaR2U6-3CIsQxi7JJ3hz9CgE1pxSe-L0TK5iiGYfhF0v00yOA7tx6REootcSVLIviFo1tqXyHBNQ0mWPO7f5kgu_OLGoG191l2aMYooawAUDR0BsJwZAC2mqxHIqYZqLUnK5CC1ziqQbLIIwwXTsY2vBKOc7Hju_UX3UsGJKyulqNpQuVYd4WI0lJ5V6ObBgxO_zgUBwgdJotFIoIqWtQ7GCKT7xoJtgDQUl4twwAqqdEyVSDYJ6wWrZ5pxvWByYbosYJMeZAcnVi4W42jIq4rnnl6re2HgCaQ2r0se9w83NrqE1DHFVoaZqbsTdMovfzo/fichafinanceira">Faturas</a>
      </ae-buttons-button>
      <ae-buttons-button>
        <a href="/fichafinanceira/sempermissao">Faturas sem permissão</a>
      </ae-buttons-button>
    </ae-buttons>
  </nav>
  <main>
    <h1>Eleva Agenda Edu</h1>
    <h2>Squad Eleva Pay 🎉</h2>
    <p>
      Projeto iniciado pela Squad Eleva PAY
    </p>
    <h2>Componentes</h2>
    <h3>AE Tabs</h3>
    <ae-tabs [style.width]="'100%'">
      <ae-tabs-item data-active>
        Abertos
      </ae-tabs-item>
      <ae-tabs-item>
        Pagos
      </ae-tabs-item>
      <ae-tabs-item>
        Cancelados
      </ae-tabs-item>
    </ae-tabs>
    <h3>AE Cards</h3>
    <ae-cards [ngClass]="'error'" [style.width]="'270px'">
      <div class="descricao">Acordo feito no dia 02/10/2021</div>
      <p class="titulovalor">
        <strong>Inscrição para as olimpíadas</strong><br />
        <img src="assets/img/icons/coin.svg">R$ 1200,00
      </p>
      <div class="vencimento">Pague até o dia 02/10/2021</div>
    </ae-cards>
    <ae-cards [style.width.px]="270">
      <div class="descricao">Cobrança recorrente - 3 de 12</div>
      <p class="titulovalor">
        <strong>Inscrição para as olimpíadas</strong><br />
        <img src="assets/img/icons/coin.svg">R$ 1200,00
      </p>
      <div class="vencimento">Pague até o dia 02/10/2021</div>
    </ae-cards>
    <h3>AE Tags</h3>
    <ae-tags>Aberto</ae-tags>
    <ae-tags>Pago</ae-tags>
    <ae-tags>Cancelado</ae-tags>
    <ae-tags>Atrasado</ae-tags>
    <ae-tags class="info"><img src="assets/img/icons/check.svg" alt="Copiado">Copiado</ae-tags>

    <h3>AE Infos</h3>
    <ae-infos class="barcode" [style.width.px]="350">
      23790.50400 41990.412151
      09008.109200 9 78600000019900
    </ae-infos>
    <ae-infos [style.width.px]="350">
      Cobrança recorrente
      <div>1 de 12</div>
    </ae-infos>
    <ae-infos class="error" [style.width.px]="350">
      Esta fatura já venceu. O valor será atualizado com juros e multas.
    </ae-infos>
    <div style="clear: both;"></div>
    <h3>AE Buttons</h3>
    <p>
      <ae-buttons>
        <ae-buttons-button>
          <a href="#">Fatura</a>
        </ae-buttons-button>
      </ae-buttons>
    </p>
    <p>
      <ae-buttons>
        <ae-buttons-button>
          <a href="#">Pix</a>
        </ae-buttons-button>
        <ae-buttons-button>
          <a href="#">Fatura</a>
        </ae-buttons-button>
      </ae-buttons>
    </p>
    <p>
      <ae-buttons>
        <ae-buttons-button class="ae-buttons-white">
          <a href="#">Visualizar Fatura</a>
        </ae-buttons-button>
        <ae-buttons-button>
          <a href="#">Copiar Código</a>
        </ae-buttons-button>
      </ae-buttons>
    </p>
    <p>
      <ae-buttons>
        <ae-buttons-button>
          <a href="#">Ir para o Portal<img src="assets/img/icons/externalink.svg"></a>
        </ae-buttons-button>
      </ae-buttons>
    </p>
  </main>
</div>
